import { spFolderItemSetKeyFacet } from '../../dataSource/Keys';
import ListFilterUtilities from '@ms/odsp-datasources/lib/utilities/list/ListFilterUtilities';
import { Key } from '@ms/items-view/lib/private/models/KeyFacet';

/**
 * @internal
 */
export function getFilteredItemSetKey(itemSetKey: typeof spFolderItemSetKeyFacet.type): (params: {
  filterField: string;
  filterValues: string[];
  filterType: string;
  useLookupId: boolean;
}) => Key<typeof spFolderItemSetKeyFacet.type> {
  const getFilteredItemSetKeyInner = (params: {
    filterField: string;
    filterValues: string[];
    filterType: string;
    useLookupId: boolean;
  }): Key<typeof spFolderItemSetKeyFacet.type> => {
    const updatedFilterParams = ListFilterUtilities.updateFilterInfo(
      itemSetKey.filterParams || '',
      params.filterField,
      params.filterValues,
      params.filterType,
      params.useLookupId);

    return spFolderItemSetKeyFacet.serialize({
      ...itemSetKey,
      // need to make sure when set it to undefined when updatedFilterParams is empty string.
      filterParams: updatedFilterParams || undefined
    });
  };
  return getFilteredItemSetKeyInner;
}
